import { IDownloadedFile } from "@/domain/entities/lineInfo";
import { IResultData } from "@/domain/entities/shared/result";
import { GetFileUrlUseCase } from "@/domain/usecases/file/GetFileUrl";
import { DownloadFileUseCase } from "@/domain/usecases/file/DownloadFile";
import TYPES from "@/ioc/identifiers";
import { container } from "@/ioc/inversify.config";
import { defineStore } from "pinia";

const downloadFile = () =>
  container.get<DownloadFileUseCase>(TYPES.DownloadFileUseCase);

const getFileUrl = () =>
  container.get<GetFileUrlUseCase>(TYPES.GetFileUrlUseCase);

export const useFileStore = defineStore("file", {
  state: () => {
    return {};
  },
  getters: {},
  actions: {
    downloadFile(fileUid: string): Promise<IResultData<IDownloadedFile>> {
      return downloadFile().execute(fileUid);
    },

    getFileUrl(
      fileUid: string,
      useCache: boolean,
      key: string
    ): Promise<IResultData<string>> {
      return getFileUrl().execute(fileUid, useCache, key);
    },
  },
});
